<template>
  <div id="technology">
    <v-container :pa-0="$vuetify.breakpoint.smAndDown">
      <v-layout align-center justify-space-between column>
        <v-flex mb-5 text-xs-center>
          <h1
            class="
              font-weight-black
              blue-grey--text
              text--darken-4
              display-2
              text-center
            "
          >
            Strategic Consulting
          </h1>
          <br />
          <hr />
        </v-flex>
        <v-flex mt-5 mb-5>
          <div>
            <v-tabs
              color="grey"
              hide-slider
              grow
              v-model="tab"
              icons-and-text
              active-class="indigo--text text--darken-2 grey lighten-5 subheading font-weight-bold"
            >
              <v-tab class="text-capitalize" href="#tab-0">
                Corporate Governance
                <v-icon :class="{ 'indigo--text': tab == 'tab-0' }"
                  >people</v-icon
                >
              </v-tab>
              <v-tab class="text-capitalize" href="#tab-1">
                Transaction Advisory
                <v-icon :class="{ 'indigo--text': tab == 'tab-1' }"
                  >fact_check</v-icon
                >
              </v-tab>
              <v-tab class="text-capitalize" href="#tab-2">
                Tailored Research
                <v-icon :class="{ 'indigo--text': tab == 'tab-2' }"
                  >zoom_in</v-icon
                >
              </v-tab>
              <v-tab-item
                v-for="(item, index) in items"
                :value="'tab-' + index"
                :key="index"
              >
                <v-card flat class="grey lighten-2">
                  <div
                    class="rotatingItemBackground"
                    :class="{
                      rotatingItemBackgroundMobile:
                        $vuetify.breakpoint.smAndDown,
                    }"
                  >
                    <v-card-text>
                      <p
                        class="
                          rotatingBullets
                          blue-grey--text
                          text--darken-4
                          subheading
                        "
                      >
                        {{ item.text }}
                        <br />
                        <br>
                        <ul style ="text-align:left">
                            <li>{{item.list1}}</li>
                            <li>{{item.list2}}</li>
                            <li>{{item.list3}}</li>
                            <li>{{item.list4}}</li>
                        </ul>
                      </p>
                    </v-card-text>
                  </div>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </div>
        </v-flex>
        <v-flex mt-5>
          <p
            class="
              font-weight-medium
              blue-grey--text
              text--darken-4
              headline
              text-center
              subheaders
            "
          >
            RETHYMOS Strategic Consulting in Depth
          </p>
          <hr />
        </v-flex>
        <v-flex mb-1 mt-5>
          <p id="mainTechnologyText" class="title font-weight-light">
            <br />
            With our multi-industry experience in corporate governance and
            transaction advisory work as well as international experience in
            strategic consulting, we provide professional services and add value
            to businesses of various sizes (including start-ups, scale-ups and
            established organizations) in the process of analyzing their “as-is”
            position, understanding what they want to do next, formulating
            strategies and action plans, working as a team towards the goal and
            assessing outcomes.
          </p>
          <p id="mainTechnologyText" class="title font-weight-light">
            <br />
            Our strategic consulting comprises a wide spectrum of services with
            particular expertise in corporate governance, transaction advisory
            and tailored research. Our aim is to assist businesses to meet their
            needs and objectives such as building up a robust management and
            operational structure as a solid foundation for the business to
            grow, identifying potential targets and opportunities of
            investments, pursuing cross-border transactions, cutting cost,
            restructuring, development of new services or products and expansion
            into new markets.
          </p>
          <p id="mainTechnologyText" class="title font-weight-light">
            <br />
            With the client’s best interests in mind, we keep an unbiased and
            open mindset to help identify issues, ask challenging questions,
            provide in-depth analysis, formulate strategies, suggest pragmatic
            and creative solutions, streamline processes, seek opportunities for
            collaboration or growth, set measurable milestones and conduct
            holistic reviews from all possible angles. We see our clients’
            success as our own success.
          </p>
          <br />
          <br />
          <br />
        </v-flex>
        <!-- <v-flex mt-3 mb-5>
          <p
            class="
              font-weight-medium
              blue-grey--text
              text--darken-4
              headline
              text-center
              subheaders
            "
          >
            Our Areas of Expertise Include:
          </p>
          <hr />
        </v-flex>
        <v-flex id="additionalServices" mb-5 pa-2>
          <v-layout row>
            <v-flex :offset-xs1="$vuetify.breakpoint.mdAndUp">
              <div
                class="service"
                v-for="(service, index) in otherServices"
                :key="index"
              >
                <div class="serviceArea headline">
                  <v-icon color="#18519a">{{ service.icon }}</v-icon> |
                  {{ service.area }}
                </div>
                <div class="serviceAreaContent subheading">
                  {{ service.content }}
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-flex> -->
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tab: "",
      // technologyCoreServices: [
      //   "CTO on demand services",
      //   "Business and process consulting",
      //   "Technology and development consulting",
      //   "Systems administration outsourcing",
      //   "Systems development outsourcing",
      //   "Software architecture and design",
      //   "Software development team building",
      //   "Integration assistance with third-party systems",
      //   "Targeted development projects to enhance performance",
      //   "Networks for trading floors, exchange colocation fit out and enhancement",
      //   "Trading turrets and telecommunications to meet compliance needs",
      //   "Consultant reports on exchange caveats for performance",
      //   "Legacy trading system audit",
      //   "Performance and security audits of financial systems",
      //   "UI design and UX improvement assistance",
      //   "Oversight and leadership of development teams",
      //   "Audit of software development methodologies (SQA)",
      // ],
      otherServices: [
        {
          area: "Performance",
          content:
            "Improving performance of trading systems to best in breed in both the software and hardware domain.",
          icon: "timer",
        },
        {
          area: "Security",
          content:
            "Securing systems, networks, refinding policies and bringing them forward to meet compliance requirements.",
          icon: "security",
        },
        {
          area: "Strategy Improvement",
          content:
            "Reviewing trading strategies, pricing and risk management systems for deficiencies and suggesting ways for improvement.",
          icon: "show_chart",
        },
        {
          area: "Trading Safety Audit",
          content:
            "Analysing corporate policies on trading safety measures, fat-finger and other limits for compliance with regulations and best practice.",
          icon: "assignment",
        },
        {
          area: "Practice Improvement",
          content:
            "Reviewing current business practices and advising how to bring them in line with current best practices and codes of conduct.",
          icon: "show_chart",
        },
        {
          area: "Technology Issues",
          content:
            "Resolving technological issues in legacy and existing systems, including trouble identification and resolution.",
          icon: "report_problem",
        },
        {
          area: "Administration",
          content:
            "Accepting outsourced administrative management of technology systems in data centers for trading operations.",
          icon: "supervisor_account",
        },
        {
          area: "Projects",
          content:
            "Accepting outsourced projects to research, design and develop proprietary trading systems and other mission critical applications.",
          icon: "folder_open",
        },
      ],
      items: [
        {
          area: "Corporate Governance",
          text: "Whether your company is a start-up, scale-up or well established organization, good corporate governance is one of the essential elements to your company’s success. It promotes trust among the shareholders and other stakeholders such as directors, senior management executives, customers, suppliers, financiers, regulators and the community. We can assist your company to set up a good corporate governance which should entail the following: ",
          list1:
            "A clear, transparent and documented structure of rules, policies, practices and procedures for managing a company and attaining the company’s objectives",
          list2:
            "A holistic application of good management, encompassing every sphere of management from formulation of plans and policies, implementation of action plans and measures, internal control and supervision, performance / outcome assessment to corporate disclosure",
          list3:
            "A comprehensive structure to cover areas such as business strategy, corporate culture, compliance and risk management, ESG (environmental, social and governance), compensation and employee benefits, taking into account the company’s objectives and vision",
          list4:
            "Key design principles including an effective and accountable board of directors, transparency around roles and responsibilities of senior management, balanced objectives among and fairness to all interested stakeholders, and a clear organization and reporting structure to foster responsibility and accountability",
        },
        {
          area: "Transaction Advisory",
          text: "Whether you are a buyer or seller or an investor seeking for short-term or long-term profits, we can assist you in completing the transaction in a cost and time-efficient manner, tailored to your business objectives and financial goals. By leveraging our extensive experience in transaction advisory work relating to mergers, acquisitions, private equity investments, equity and debt capital markets and joint ventures, we can, working together with your other professional advisers, help you sail through different stages of a transaction starting from exploring opportunities, planning, negotiation, due diligence, documentation, execution and post-completion considerations. Key common issues to be considered/dealt with in pursuing a transaction include:",
          list1:
            "Share or business purchase, which determines the approach of negotiation, scope of due diligence and transaction documentation",
          list2:
            "Preparatory steps such as valuation of the company/business, pre-deal reorganization, intra-group transfers of assets and shares and capital or debt financing for the transaction",
          list3:
            "Preparation of agreements including confidentiality agreements, term sheets, shareholders agreements, subscription agreements, share/business purchase agreements, limited partnership agreements and side letters",
          list4:
            "Other considerations in respect of tax obligations, corporate governance, public relations and human resources",
        },
        {
          area: "Tailored Research",
          text: "Asking the right questions and getting the basics correct are fundamental to building a healthy business and unlocking your company’s growth. With our multi-industry experience in corporate governance and transaction advisory work as well as international experience in strategic consulting, we could assist you in designing the research scope and methodology and provide you with tailored research for your specific goals and needs such as business set-up, re-positioning, development of new products, expansion into new sectors or markets, fostering collaboration with other companies and acquisition/disposal of businesses. Our tailored research services cover various aspects including: ",
          list1:
            "Discovery process for identifying potential targets and opportunities of acquisitions, mergers, investments, financing or restructuring",
          list2:
            "Documents organization, review and summary for specific purposes",
          list3:
            "Desktop research, comparison and overview of existing or proposed regulatory framework and licensing requirements",
          list4:
            "Access to a global network of professionals and service providers",
        },
        {
          area: "Technology Consulting",
          text: "Many businesses find it challenging to deploy, maintain, and protect their technology. Whether you are looking to keep IT costs predictable, avoid unexpected problems, communicate more effectively or make a plan for business continuity, RETHYMOS has a solution for you. By leveraging best of breed integrated applications we are able to deliver exceptional, cost effective IT support. Our integrated ticketing system creates an efficient and coordinated IT support. We help financial institutions address their business-critical concerns, regardless of the stage in their business or project cycles. More importantly, not only do we advise our clients on the best possible solution, but we are committed to be with them until that solution is operational.",
        },
      ],
      tools: [
        {
          text: "Automated financial matching engine(millions of msgs / sec at microsecond level)",
        },
        {
          text: "Internal crossing and deal reporting engine",
        },
        {
          text: "Market data dissemination tools",
        },
        {
          text: "HFT and Automated market making systems",
        },
        {
          text: "FIX engine gateways",
        },
        {
          text: "High - speed binary API interfaces",
        },
      ],
    };
  },
};
</script>

<style scoped>
#technology {
  padding-top: 7%;
  line-height: 2;
}

#mainTechnologyText {
  line-height: 1.6 !important;
  padding: 0px 6%;
}

.pageTitleText {
  letter-spacing: 5px;
  font-size: 50px;
}

.carouselText {
  font-size: 17px;
}

#coreServices {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: space-between;
  font-size: 25px;
}

.service {
  margin-bottom: 3%;
}

.serviceArea {
  width: max-content;
  color: #18519a;
}

.serviceAreaContent {
  margin-bottom: 10px;
}

.rotatingItemBackground {
  width: 90%;
  text-align: center;
  margin: auto;
  padding-top: 2%;
}

.rotatingItemBackgroundMobile {
  padding: 0%;
  width: 100%;
}

.introTabText {
  font-size: 18px;
  font-weight: 500;
}
</style>